<template>
  <div class="col-12 col-lg-6 pr-1">
    <div class="ibox mb-2">
      <div class="ibox-title style_2">
        <h5>{{ $t("navigations.import protocol") }}</h5>
        <div class="ibox-tools"></div>
      </div>
      <div class="ibox-content">
        <!-- Drag & Drop / Browse Box -->
        <div
          class="import-box mb-3"
           :class="{ 'import-box--active': dragActive, 'import-box--disabled': studyFiles!=null }"
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"          
           :style="{ pointerEvents: studyFiles ? 'none' : 'auto', opacity: studyFiles ? 0.6 : 1 }"
        >
          <h6>Drag & drop study Protocol here</h6>
          <p class="text-muted mb-0">or click to browse files</p>
          <input
            ref="fileInput"
            accept=".pdf"
            type="file"
            class="d-none"
            @change="previewFiles"
          />
          <!-- Selected filename -->
          <div v-if="studyFiles" class="uploaded-file mt-2">
            <i class="fa fa-file-pdf-o me-2"></i>
            {{ studyFiles.name }}
            <!-- <i class="fa fa-times ms-2 cursor-pointer" @click.stop="removeFile"></i> -->
          </div>
          <div class="mt-2">
            <button
              class="btn btn-primary btn-sm py-0"
              type="button"
              @click="browseFiles"
              :disabled="showLoading || !!studyFiles"
            >
              <i class="fa fa-folder me-2"></i> Browse Files
            </button>
          </div>
        </div>

        <!-- Supported format & download template link -->
        <div class="alert al_min-height alert-light d-flex justify-content-between mb-0 py-2">
          <small><strong>Supported format:</strong> .pdf</small>
        </div>

        <!-- Validation error -->
        <span v-if="validations[0]==true" class="errorClass">
          {{ $t("navigations.please upload a pdf file") }}
        </span>
        <span v-if="validations[1]==true" class="errorClass">
          {{ $t("navigations.please upload a file") }}
        </span>

        <!-- Cancel / Import buttons -->
        <div class="d-flex justify-content-end mt-3">
          <button
            v-if="showCancel"
            class="btn btn-outline-secondary me-2 btn-sm py-0"
            type="button"
            @click="removeFile()"
            :disabled="showLoading"
          >
            <i class="fa fa-times me-1"></i> Cancel
          </button>
           <button class="btn btn-primary btn-sm  position-relative py-0" type="button" :disabled="showLoading" @click="studyDataExport()">
            <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': showLoading == false, 'opacity-1': showLoading == true }">
              <img src="../../assets/img/loading.gif" class="loading-btn-img" width="15" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': showLoading == false, 'opacity-0': showLoading == true }">{{
              $t("navigations.import protocol") }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
   <customModal v-if="initialStudyLoader==true" :containersm=true :hideClose="true">
    <template #title>
      {{ $t("navigations.import protocol") }}
    </template>
    <template #body>
      <div class="progress mb-3">
        <div 
            class="progress-bar progress-bar-striped progress-bar-animated h-100" 
            role="progressbar" 
            :style="{ width: progress + '%' }" 
            :aria-valuenow="progress" 
            aria-valuemin="0" 
            aria-valuemax="100"
          >
            {{ progress }}%
          </div>
      </div>
      <div class="text-center">
        <p class="mb-1">Processing: {{ currentProcessingFile }}</p>
        <p class="mb-0 text-muted small">Please don't close this window</p>
      </div>
    </template>
  </customModal>
</template>

<script>
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import ResetPassword from "../ForgotPassword/ResetPassword.vue";
export default {
  name: "uploadstudyprotocol",
  components:{
    customModal
  },  
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      dataToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJUeXBlIjoiQXBwbGljYXRpb24iLCJPcmdhbmlzYXRpb24iOiJTdHVkeUltcG9ydCIsIkFwcE5hbWUiOiJEYXRhRXh0cmF0IiwiZXhwIjo0ODg4NTU0MDk5fQ.MzdW7sv6VevOJkyRDIeziSrChlDJf3sr9WEfGRJXaFA",
      showLoading: false,
      studyFiles: null,   
      validations:[false,false],
      showValidation: false,
      idToken: "",
      protocolDetails: {
        fileName: "",
        status: "",
        documentRefId: "",
        documentVersion: "",
        uploadResultRefId: "",
        uploadResultVersion: ""
      },
      azuredata: {
        DocumentDescription: "",
        DocumentTitle: "",
        OrganizationId: ""
      },
      selectedFile:"",
      dragActive: false,
      initialStudyLoader:false,
      showCancel:false,
      progress:0, 
      currentProcessingFile:'',
      dataInput:""
    };
  },
  mounted() {
    this.idToken = store.getters.getIdToken;
  },
  methods: {
    browseFiles() {
      if (!this.studyFiles) {
        this.$refs.fileInput.click();
      }
    },
    previewFiles(event) {
      this.validations = [false, false];
      const file = event.target.files[0];
      this.selectedFile=file.name
      this.showCancel=true
      if (file && /\.pdf$/i.test(file.name))  {
        this.studyFiles = file;
        this.validations = [false, false];
      } else if (!file) {
        this.studyFiles = null;
        this.validations[1] = true;  // No file uploaded
      } else {
        this.studyFiles = null;
        this.validations[0] = true;  // File uploaded, but invalid type
      }
    },
    removeFile() {
      this.validations=[false,false]
      this.studyFiles = null;
      this.$refs.fileInput.value = "";
      this.showCancel=false
    },
    onDragOver() {
      this.dragActive = true;
    },
    onDragLeave() {
      this.dragActive = false;
    },
    onDrop(e) {
      this.dragActive = false;
      const file = e.dataTransfer.files[0];
      this.selectedFile=file.name
      this.showCancel=true
      if (file && /\.pdf$/i.test(file.name))  {
        this.studyFiles = file;
        this.validations = [false, false];
      } else if (!file) {
        this.studyFiles = null;
        this.validations[1] = true;  // No file uploaded
      } else {
        this.studyFiles = null;
        this.validations[0] = true;  // File uploaded, but invalid type
      }
    },
    async validateNull() {
      if(!this.studyFiles){
        this.validations[1] = true;
        return;
      }      
    },
    async studyDataExport() {
      await this.validateNull()
      if(this.validations[1]==true)
        return;
      await this.uploadData();
    },
    async uploadData() {
      this.initialStudyLoader=true
      this.validations = [false,false];
      this.progress = 0;
      this.currentProcessingFile = 'Uploading: ' + this.studyFiles.name;

      const formData = new FormData();
      formData.append("file", this.studyFiles);
      let fakeProgress = 0;
      let progressTimer = setInterval(() => {
        if (fakeProgress < 90) {
          fakeProgress += 1;
          this.progress = fakeProgress;
        } else {
          clearInterval(progressTimer);
        }
      }, 130); 

      try {
        const response = await axios.post(
          `${this.baseurl}/forms-ml/studyprotocol/studyprotocoltoexcel`,
          formData,
        );
        // Manually set progress to 100%
           // Show ongoing process
           // Keep it at 100 while other steps complete
          this.dataInput = response.headers['xlid'];
                
          const jsonData = JSON.stringify(response.data, null, 2); // Pretty-print JSON
          const blob = new Blob([jsonData], { type: 'application/json' });

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);

          const downloadName = this.studyFiles.name.replace(/\.pdf$/, '');  
          link.download = `${downloadName}.json`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      
        this.progress = 95;
        // Continue the next steps
        await this.createDocumentDMS();
        this.progress = 98;
        await this.dataService();
        this.progress = 100;
         this.showLoading = false
        this.currentProcessingFile = 'Completed';
        this.initialStudyLoader=false
      } catch (err) {
        this.studyFiles=null
         this.initialStudyLoader=false
         this.showLoading = false
        this.protocolDetails.status = "Upload failed in datalake";
        await this.CreateProtocolDetails();
      } finally {
        this.studyFiles=null
        this.progress = 0;
        this.currentProcessingFile = '';
      }

    },
    async createDocumentDMS() {
      const idToken=store.getters.getIdtoken
      this.azuredata.DocumentDescription = "Uploaded protocol to DMS.";
      const dms = new FormData();
      dms.append("Document", this.studyFiles);
      dms.append("DocumentTypeName", "STUDY_PROTOCOL");
      dms.append("DocumentTitle", this.azuredata.DocumentTitle);
      dms.append("DocumentDescription", this.azuredata.DocumentDescription);
      dms.append("OrganizationId", this.azuredata.OrganizationId);
      const res = await axios.post(
        `${this.baseurl}/dms/document/create`,
        dms,
        { headers: { Authorization: `Bearer ${this.idToken}`, "Content-Type": "multipart/form-data" } }
      );
      this.protocolDetails.documentRefId = res.data.data[0];
      this.protocolDetails.documentVersion = res.data.data[1];
    },
     async dataService() {
        try {
            const url = `${this.baseurl}/dataservices/centraldatahub/download/${this.dataInput}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${this.dataToken}`,
                    Accept: '*/*'
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            const downloadName = this.studyFiles.name.replace(/\.pdf$/, '')
            link.download = `${downloadName}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            const downloadedFile = new File([blob], `${downloadName}.xlsx`, { type: response.headers['content-type'] });
            this.currentProcessingFile = 'Downloading to json...';
            await this.saveDownloadedFileToDMS(downloadedFile);
            await this.CreateProtocolDetails(downloadedFile);
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    },
    async saveDownloadedFileToDMS(file) {
      const dms = new FormData();
      dms.append("Document", file);
      dms.append("DocumentTypeName", "STUDY_PROTOCOL_RESPONSE");
      dms.append("DocumentTitle", file.name);
      dms.append("DocumentDescription", "Processed protocol in DMS.");
      dms.append("OrganizationId", this.azuredata.OrganizationId);
      const res = await axios.post(
        `${this.baseurl}/dms/document/create`,
        dms,
        { headers: { Authorization: `Bearer ${this.idToken}`, "Content-Type": "multipart/form-data" } }
      );
      this.protocolDetails.uploadResultRefId = res.data.data[0];
      this.protocolDetails.uploadResultVersion = res.data.data[1];
      this.protocolDetails.fileName = file.name;
      this.protocolDetails.status = "Success";
    },
    async CreateProtocolDetails(downloadfile) {
      await axios.post(
        `${this.baseurl}/management/document/createstudyprotocol`,
        this.protocolDetails,
        { headers: { Authorization: `Bearer ${this.idToken}` } }
      ).then((res)=>{
        if(res.data){
          this.CreateDataScrap(downloadfile,res.data);
           alert("File uploaded successfully.");
        }      
       
        this.removeFile()
      }).catch((err)=>{
        console.error(err)
      })
      
    },
    async CreateDataScrap(file,refId) {
      const fd = new FormData();
      fd.append("File", file);
      await axios.post(
        `${this.baseurl}/management/studyprotocol/importprotocol?protocolRefId=${refId}`,
        fd,
        { headers: { Authorization: `Bearer ${this.idToken}` } }
      );
    },
  }
};
</script>

<style scoped>
.progress {
  height: 20px;
  border-radius: 12px;
  overflow: hidden;
  margin: 15px 0;
}

.progress-bar {
  font-weight: 600;
  
}
.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
.import-box {
  border: 2px dashed #618bd7;
  border-radius: 5px;
  padding: 2rem 1rem;
  text-align: center;
  background: #f7fafd;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  position: relative;
}
.import-box--active {
  border-color: #3867d6;
  background: #eaf1ff;
}
.uploaded-file {
  color: #618bd7;
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
}
.fa-file-pdf-o {
  color: #d9534f;
}
.cursor-pointer {
  cursor: pointer;
}
.errorClass {
  color: #e03e2d;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: block;
}
.loading-img {
  margin-right: 0.5rem;
  vertical-align: middle;
}
</style>
